import styled from "styled-components";
import { MarketplaceMain, MarketplaceNavbarWrapper } from "../../Marketplace/MarketplaceNavbar/MarketplaceNavbar.styled";
import { Link } from "react-router-dom";

export const UserNavbarWrapper = styled(MarketplaceNavbarWrapper)`
  overflow-y: scroll;
  padding-bottom: 10px;
  margin-bottom: 5px;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    opacity: 0;
  }
  @media (max-width: 767.98px) {
    margin-top: 0;
  }
`;

export const UserNavbarMain = styled(MarketplaceMain)`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  & div {
    margin-left: 5px;
  }
`;

export const UserProfileButton = styled(Link)`
  background: #0088cc;
  border-radius: 25px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #ffffff;
  border: none;
  width: auto;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: 1px solid #0088cc;
  transition: 0.2s;
  white-space: nowrap;
  padding: 0 15px;
  &:hover {
    background: transparent;
    color: #0088cc;
    border: 1px solid #0088cc;
  }
`;
